export default "__VITE_ASSET__BIBUUlXI__"